import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from "@angular/core";
import { ManagementComponent } from "../management";
import { CategoryModel } from "../../../shared/models/cameralla-category.model";
import * as _ from "underscore";
import { PhotoOrder } from "../../../shared/models/cameralla-photo-order.model";
import { Observable, of } from "rxjs";
import { AppService } from "../../../core/services/app.service";
import { ActivatedRoute, Router } from "@angular/router";
import { HttpClient } from "@angular/common/http";
import { ToastrService } from "ngx-toastr";
import { CategoryService } from "../../category/services/category.service";
import { CamerallaAuthService } from "../../../shared/services/authentication-services/cameralla-auth.service";
import { UserService } from "../../user/services/user.service";
import { NgbActiveModal, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { TagInputComponent } from "ngx-chips";
import { GroupService } from "../../user/services/group.service";
import { PartnerService } from "../../../shared/services/partner.service";
import { EventService } from "../../../shared/services/event.service";
import { UploadPhotoService } from "../../../shared/services/upload-photo.service";

@Component({
  selector: "app-filter-form",
  templateUrl: "./filter-photo-form.html",
})
export class FilterPhotoForm extends ManagementComponent {
  categories = [];
  selectedFilters = [];
  photoOrder: PhotoOrder;
  loaded: boolean = false;
  videoMode = false;
  categoryNameArr = [];
  public static filterAPI = AppService.getApiUrl() + "/api/defaultFilters";
  currentFilterTags = null;
  currentDropdownList = null;
  @ViewChild("inputTag") inputTag: TagInputComponent;

  constructor(
    protected router: Router,
    protected http: HttpClient,
    protected toastr: ToastrService,
    protected uploadPhotoService: UploadPhotoService,
    protected categoryService: CategoryService,
    protected authService: CamerallaAuthService,
    protected userService: UserService,
    protected eventService: EventService,
    protected _modalService: NgbModal,
    protected activeModal: NgbActiveModal,
    protected groupService: GroupService,
    protected route: ActivatedRoute
  ) {
    super(
      router,
      http,
      toastr,
      uploadPhotoService,
      categoryService,
      authService,
      userService,
      eventService,
      _modalService,
      groupService,
      route
    );
    this.localUserId = +this.authService.getLocalUserInfo()["id"];
  }

  public partnerArr = [];

  @Input()
  filterModel: any = {
    partner: {},
  };

  @Input()
  hidePartner: boolean = false;

  @Input()
  groupId = null;

  @Input()
  isEdit: boolean = false;

  @Output()
  onRefresh: EventEmitter<any> = new EventEmitter<any>();

  validatorTag = [this.checkValidTag.bind(this)];

  private checkValidTag(value) {
    if (this.categoryNameArr.includes(value.value.toLowerCase())) {
      return {
        invalidName: true,
      };
    }

    return null;
  }

  public errorMessages = {
    invalidName: "Tag name is not allowed to duplicate with category name!",
  };

  ngOnInit() {
    if (!this.isEdit) {
      this.filterModel = {
        text: "",
        tags: [],
        sort_by: {
          selectedBrowse: {
            name: "Views",
            value: "viewsCount",
          },
          selectedOrder: {
            name: "Ascending",
            value: "ASC",
          },
          selectedTimeFrame: {
            name: "All time",
            value: "allTime",
          },
        },
        order: "ASC",
        categoriesList: [],
        isDropdown: 0,
        dropDownList: [],
      };
    } else {
      if (this.filterModel.partner.value === "video") {
        this.videoMode = true;
      }
    }
    this.photoOrder = new PhotoOrder();

    this.categoryService
      .getCategories()
      .toPromise()
      .then(
        (response) => {
          if (response["Data"]) {
            this.categories = response["Data"];
            this.categories.forEach((item) => {
              this.categoryNameArr.push(item.name.toLowerCase());
            });
            this.http
              .get(PartnerService.partnerAPI + `?filter[where][groupId]=null`)
              .subscribe(
                (res: any) => {
                  if (res.Data && res.Data.length) {
                    // Config permission for user Kampsport can edit filter
                    if (this.onlyKampsport) {
                      this.partnerArr = res.Data.filter((item) => {
                        return item.value == "kampsport";
                      });
                    } else {
                      this.partnerArr = res.Data;
                    }

                    if (!this.filterModel.partner) {
                      this.filterModel.partner = this.partnerArr[0];
                    }

                    this.partnerArr.push({
                      name: "Video",
                      value: "video",
                      id: "video",
                    });

                    this.loaded = true;

                    setTimeout(() => {
                      this.inputTag.onRemove.subscribe((tag) => {
                        this.removeTag(tag);
                      });
                    }, 0);
                  }
                },
                (error) => {
                  this.toastr.error(error.error.Message, "Error");
                }
              );

            if (this.filterModel.categoriesWithSub) {
              this.selectedFilters = this.filterModel.categoriesWithSub;
            }

            this.photoOrder.selectedBrowse =
              this.filterModel.sort_by.selectedBrowse;
            this.photoOrder.selectedOrder =
              this.filterModel.sort_by.selectedOrder;
            this.photoOrder.selectedRating =
              this.filterModel.sort_by.selectedRating;
            this.photoOrder.selectedTimeFrame =
              this.filterModel.sort_by.selectedTimeFrame;
          }
        },
        (error) => {
          console.log("GET CATEGORY ERROR " + error);
          Promise.reject(error);
        }
      );

    this.currentFilterTags = [...this.filterModel.tags];
    this.currentDropdownList = this.filterModel.dropDownList
      ? [...this.filterModel.dropDownList]
      : null;
  }

  isSelected(filter, subCategory?) {
    for (const each of this.selectedFilters) {
      if (subCategory) {
        if (
          each["value"] === filter["id"] &&
          each["subCategories"] &&
          each["subCategories"].includes(subCategory.id)
        ) {
          return true;
        }
      } else {
        if (each["value"] === filter["id"]) {
          return true;
        }
      }
    }

    return false;
  }

  selectFilter(category: CategoryModel, subCategory?) {
    const selected_tag = { display: category.name, value: category.id };

    const isSelected: any = this.selectedFilters.find((each) => {
      return each["value"] === selected_tag["value"];
    });

    if (!isSelected) {
      if (subCategory) {
        const filterWithSub = {
          display: category.name,
          value: category.id,
          ...category,
          subCategories: [subCategory.id],
        };

        this.selectedFilters.push(filterWithSub);
      } else {
        this.selectedFilters.push({
          display: category.name,
          value: category.id,
          ...category,
        });
      }
    } else {
      if (subCategory) {
        if (!isSelected.subCategories) {
          isSelected.subCategories = [];
        }
        const index = isSelected.subCategories.indexOf(subCategory.id);
        if (index < 0) {
          isSelected.subCategories.push(subCategory.id);
        } else {
          isSelected.subCategories.splice(index, 1);
        }
      } else {
        this.selectedFilters = _.filter(this.selectedFilters, (item: any) => {
          return item.value != category.id;
        });
      }
    }
  }

  selectBrowse(order: { name: string; value: string }, event) {
    event.stopPropagation();
    this.photoOrder.selectedBrowse = order;
  }

  selectPartner(partner: any, event) {
    this.videoMode = partner.value === "video";
    this.filterModel.partner = partner;
  }

  selectRating(rating: { name: string; value: string }, event) {
    event.stopPropagation();
    this.photoOrder.selectedRating = rating;
  }

  selectTime(type: { name: string; value: string }, event) {
    event.stopPropagation();
    this.photoOrder.selectedTimeFrame = type;
  }

  selectOrder(order: { name: string; value: string }) {
    this.photoOrder.selectedOrder = order;
  }

  save() {
    if (!this.filterModel.text) {
      this.toastr.error("Filter name is required", "Validation error");
      return;
    }
    let categoriesList = [];
    _.each(this.selectedFilters, (item) => {
      console.log(item);
      categoriesList.push(item.value);
    });

    this.filterModel.categoriesWithSub = this.selectedFilters;
    this.filterModel.sort_by = this.photoOrder;
    this.filterModel.categoriesList = categoriesList;
    this.filterModel.order = this.photoOrder.selectedOrder.value;
    this.filterModel.tags = this.currentFilterTags;
    this.filterModel.dropDownList = this.currentDropdownList;
    this.filterModel.groupId = this.groupId;

    // Need to choose filter item.
    if (
      this.filterModel.isDropdown &&
      (this.filterModel.dropDownList.length < 1 ||
        this.filterModel.dropDownList[0].length < 1)
    ) {
      this.toastr.error("Dropdown items are required", "Validation error");
      return;
    }

    if (!this.filterModel.isDropdown) {
      this.filterModel.dropDownList = [];
    }

    this.http.put(FilterPhotoForm.filterAPI, this.filterModel).subscribe(
      (res: any) => {
        this.toastr.success("Update default filter successfully", "DONE");
        this.onRefresh.emit();
        this.activeModal.close();
      },
      (error) => {
        this.toastr.error(error.error.Message, "Update failed");
      }
    );
  }

  cancel() {
    this.activeModal.close();
  }

  public onAdding(tag: string): Observable<any> {
    return of(tag.toLocaleLowerCase());
  }

  removeTag(tag) {
    let tagPosition = this.currentFilterTags.indexOf(tag);
    this.currentDropdownList.splice(tagPosition, 1);
  }
}
